import { getCountryCallingCode, type CountryCode } from 'libphonenumber-js'

import supportedCountries from '@last/core/src/supportedCountries'

export const allSupportedPrefixes = supportedCountries.flatMap((code: CountryCode) => {
  try {
    return [`+${getCountryCallingCode(code)}`]
  } catch (_) {
    return []
  }
})
